import { getHlsFromVideoJsPlayer } from '@app/core/video-player/video-js/hls-playback-fix/hls-pdt-playback';
import { useEffect, useState } from 'react';
import Player from 'video.js/dist/types/player';
import {
  addHlsTimelineStatsListeners,
  HlsTimelineStatsCollector,
} from './hls-timeline-stats-collector';
import { EMPTY_HLS_TIMELINE_STATS, HlsTimelineStats } from './hls-timeline-stats-types';

/**
 * Subscribes to hls.js playback events and exposes buffer/playlist row snapshots
 * for the debug stats table.
 */
export function useHlsTimelineStats(player: Player | null) {
  const [stats, setStats] = useState<HlsTimelineStats>(EMPTY_HLS_TIMELINE_STATS);

  useEffect(() => {
    if (!player || player.isDisposed()) {
      setStats(EMPTY_HLS_TIMELINE_STATS);
      return;
    }

    const hls = getHlsFromVideoJsPlayer(player);
    if (!hls) {
      setStats(EMPTY_HLS_TIMELINE_STATS);
      return;
    }

    const collector = new HlsTimelineStatsCollector(hls);
    const removeListeners = addHlsTimelineStatsListeners(hls, collector, () => {
      setStats(collector.snapshot());
    });

    return () => {
      removeListeners();
      setStats(EMPTY_HLS_TIMELINE_STATS);
    };
  }, [player]);

  return stats;
}
